import React from 'react';
import { Flex, Box, Tooltip, Divider } from '@chakra-ui/react';
import { KTag, KText } from '@/ui-library/components';
import { Bell01 } from '@kula-ai/icons/outline/Bell01';
import { IconButton } from '@/components/ats';
import dayjs from 'dayjs';
import { useDateFormat } from '@/hooks/useDateFormat';

export const ScoreCardSendReminder = ({
  count,
  handleSendReminder,
  lastReminderSentAt,
}) => {
  const { dateFormat, timeFormat } = useDateFormat() || {};

  const tooltipContent =
    count > 0 ? (
      <>
        <KText size="sm-bold" color="base-white">
          Last reminder sent on
        </KText>
        <KText size="sm-medium" color="base-white">
          {dayjs(lastReminderSentAt)?.format(
            `${dateFormat.label}, ${timeFormat}`
          )}
        </KText>
      </>
    ) : null;

  return (
    <Box>
      <Tooltip
        label={tooltipContent}
        arrowSize={8}
        width="180px"
        py={3}
        px={3}
        hasArrow
        borderRadius="6px"
      >
        <Flex alignItems="center" gap="6px">
          <IconButton
            icon={Bell01}
            onClick={handleSendReminder}
            text="Send Reminder"
            iconContainerProps={{
              width: 'unset',
              height: 'unset',
              bg: 'unset',
            }}
            iconProps={{ width: '14px', height: '14px' }}
            gap="6px"
          />
          <KTag
            borderRadius="50%"
            w="20px"
            h="20px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontSize="12px"
            fontWeight="650"
            value={count}
          />
          <Divider
            height="20px"
            orientation="vertical"
            borderColor="secondary-700"
          />
        </Flex>
      </Tooltip>
    </Box>
  );
};

export default ScoreCardSendReminder;
